import React  from 'react';
import PropTypes from 'prop-types';

import SelectProgress from "core/gd-ui/select-progress/common";

export default function SpentEstimateInList(props) {

    const calculateValue = (reported, estimated) => {
        let res;
        if (!estimated) res = null;
        else if (!reported) res = 0;
        else res = Math.floor(100 * reported/estimated);
        return res
    }

    const value = props.listItem.isCollapsed ?
        calculateValue(props.listItem.reported.total, props.listItem.estimated.total)
        :
        calculateValue(props.listItem.reported.own, props.listItem.estimated.own)

    if (_.isNil(value)) {
        return <div className={Classes('no-estimate', 'ui5-txt-disabled-small', props.className)}>No estimate</div>
    } else {
        return (
            <SelectProgress renderValue="bar-50"
                            className={props.className}
                            value={value}
                            disabled={true}
                            deleteButton={false} />
        );
    }
}

SpentEstimateInList.propTypes = {
    item: PropTypes.object,
    listItem: PropTypes.object
};